export class McRAITreeNode {
  constructor(
    public item: any,
    public parent: string = 'root',
    public level: number = 0,
    public isSelected: boolean = false,
    public isDisabled: boolean = false,
    public isHidden: boolean = false,
  ) { }
}